import { createElement } from 'react';
import { Popover as OriginalPopover, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
const Popover = (props) => {
    ConfigProvider.config({
        theme: {
            primaryColor: '#f16622',
        },
    });
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(OriginalPopover, { ...props, open: !props.open ? undefined : props.open })));
};
export default Popover;
